import { count } from "../Insights/format";

const missing = (value) => value === null || value === undefined || value === "" || Number.isNaN(Number(value));

export const tileValue = (value) => (missing(value) ? "…" : count(value));
